import { SWITCH_PLAN_FEATURE_FLAG } from "../context/features/features.utils";

const triggers = [
  {
    category: "Billing",
    shortDescription: "Billing Method Updated",
    longDescription:
      "When a person updates their existing Debit card, Credit Card or Bank account on file.",
    templateName: "email.billing.updated",
    eventName: "billing.updated",
    activityEventName: "billing.account.updated",
    status: "ACTIVE",
    smartFields: ["System Data", "Client Data", "User Data", "Billing Data"],
  },
  {
    category: "Invoices",
    shortDescription: "Payment Failed",
    longDescription:
      "An attempt at invoice payment collection was unsuccessful.",
    templateName: "email.invoice.payment_failed",
    eventName: "invoice.payment_failed",
    activityEventName: "billing.payment.failed",
    status: "ACTIVE",
    smartFields: ["System Data", "Client Data", "User Data", "Invoice Data"],
  },
  {
    category: "Subscriptions",
    shortDescription: "Plan Switch",
    longDescription: "An admin has confirmed a plan switch for a member",
    templateName: "subscription-migrated",
    eventName: "subscription.migration.confirmed",
    activityEventName: "subscription.migration.confirmed",
    status: "ACTIVE",
    smartFields: [
      "System Data",
      "Client Data",
      "User Data",
      "Subscription Data",
    ],
    featureFlag: SWITCH_PLAN_FEATURE_FLAG,
  },
  {
    category: "Invoices",
    shortDescription: "Payment Succeeded",
    longDescription: "Any successful payment transaction.",
    templateName: "email.invoice.payment_succeeded",
    eventName: "invoice.payment_succeeded",
    activityEventName: "billing.payment.succeeded",
    status: "INACTIVE",
    smartFields: ["System Data", "Client Data", "User Data", "Invoice Data"],
  },
  {
    category: "Invoices",
    shortDescription: "Refund Issued",
    longDescription: "Any refund or partial refund on an invoice.",
    templateName: "email.invoice.refund",
    eventName: "invoice.refund",
    activityEventName: "billing.payment.refunded",
    status: "ACTIVE",
    smartFields: ["System Data", "Client Data", "User Data", "Invoice Data"],
  },
  {
    category: "Product",
    shortDescription: "Low Inventory",
    longDescription: "When a product option has zero left.",
    templateName: "email.product.inventory",
    eventName: "product.option_inventory",
    activityEventName: "communication.email.inventory_warning_sent",
    status: "INACTIVE",
    smartFields: ["System Data", "Client Data", "User Data", "Invoice Data"],
  },
  {
    category: "Subscriptions",
    shortDescription: "Subscription Cancelled",
    longDescription: "When a persons membership subscription is cancelled.",
    templateName: "email.subscription.cancelled",
    eventName: "subscription.cancelled",
    activityEventName: "subscription.plan.canceled",
    status: "INACTIVE",
    smartFields: [
      "System Data",
      "Client Data",
      "User Data",
      "Subscription Data",
    ],
  },
  {
    category: "Subscriptions",
    shortDescription: "Punchcard Completed",
    longDescription: "When a persons Punchcard is Completed.",
    templateName: "email.subscription.punchcard_remaining_sessions",
    eventName: "subscription.punchcard_completed",
    status: "ACTIVE",
    activityEventName: "subscription.plan.completed",
    smartFields: [
      "System Data",
      "Client Data",
      "User Data",
      "Subscription Data",
    ],
  },
  {
    category: "Subscriptions",
    shortDescription: "Recurring Subscription Due",
    longDescription: "When a persons cash subscription is due in 3 days.",
    templateName: "email.subscription.payment_due",
    eventName: "subscription.payment_due",
    status: "INACTIVE",
    activityEventName: "billing.payment.cash_reminder",
    smartFields: [
      "System Data",
      "Client Data",
      "User Data",
      "Subscription Data",
    ],
  },
  {
    category: "People",
    shortDescription: "New Person",
    longDescription: "A new account is created.",
    templateName: "email.user.profile_setup_request",
    eventName: "user.created",
    status: "INACTIVE",
    activityEventName: "communication.email.profile_sent",
    smartFields: ["System Data", "Client Data", "User Data"],
  },
  {
    category: "People",
    shortDescription: "Staff Assignment",
    longDescription: "A person is assigned to a Staff member.",
    templateName: "email.user.staff_assigned",
    eventName: "user.staff_assigned",
    activityEventName: "subscription.member.reassigned",
    status: "ACTIVE",
    smartFields: ["System Data", "Client Data", "User Data"],
  },
  {
    category: "People",
    shortDescription: "New Lead",
    longDescription: "When a persons status is set to Lead.",
    templateName: "email.user.new_lead",
    eventName: "user.status.lead",
    activityEventName: "user.lead.created",
    status: "INACTIVE",
    smartFields: ["System Data", "Client Data", "User Data"],
  },
  {
    category: "People",
    shortDescription: "Document Ready to Sign",
    longDescription: "A document was attached to a person for signature.",
    templateName: "email.user_document.created",
    eventName: "user_document.created",
    activityEventName: "user.document.requested",
    status: "ACTIVE",
    smartFields: ["System Data", "Client Data", "User Data", "Document Data"],
  },
  {
    category: "People",
    shortDescription: "Migration Account Setup Request",
    longDescription: "Member Migration request to setup account profile.",
    templateName: "email.user.migration_request",
    eventName: "user.migration_request",
    activityEventName: "communication.migration.email_sent",
    status: "INACTIVE",
    smartFields: ["System Data", "Client Data", "User Data"],
  },
  {
    category: "People",
    shortDescription: "Email Update",
    longDescription: "When a person updates their email.",
    templateName: "email.user.email_update",
    eventName: "user.email_update",
    activityEventName: "user.profile.updated",
    status: "INACTIVE",
    smartFields: ["System Data", "Client Data", "User Data"],
  },
  {
    category: "Schedule",
    shortDescription: "Event Registration",
    longDescription: "When a person registers for an event.",
    templateName: "email.event.registration",
    eventName: "event.registration",
    activityEventName: "schedule.event.registration",
    status: "INACTIVE",
    smartFields: [
      "System Data",
      "Client Data",
      "User Data",
      "Subscription Data",
    ],
  },
  {
    category: "Reports",
    shortDescription: "Daily Summary",
    longDescription:
      "Delivering daily updates with summary data for Sales, Failed Transactions, Upcoming Birthdays, Member Attendance and Expiring Memberships.",
    templateName: "report-daily-summary",
    eventName: "reports.daily_summary",
    activityEventName: "report.daily_summary.email_sent",
    status: "ACTIVE",
    smartFields: ["System Data", "Client Data", "User Data", "Billing Data"],
  },
];

export default triggers;
